import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { connectUserStream } from 'mastodon/actions/streaming';
import { me } from 'mastodon/initial_state';
import type { AppDispatch } from 'mastodon/store';

export const UserUpdatesHandler: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (!me) return;

    // Add debug logging to verify connection
    console.log('Connecting to user stream...');
    
    const unsubscribe = dispatch(connectUserStream(me));
    
    // Add debug logging for disconnection
    return () => {
      console.log('Disconnecting from user stream...');
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, [dispatch]);

  return null;
};
